<div *ngIf="{ cases: casesWithGroups$ | async, mediaParams: mediaParams$ | async, serviceGroups: serviceGroups$ | async,
  vehicle: vehicle$ | async, dropdowns: dropdowns$ | async, appointment: appointment$ | async} as data">
  <div *ngIf="!(casesWithGroupsLoading$ | async); else loadingLineItems">
    <div class="flex flex-row place-content-between w-full pb-5">
      <span class="text-base font-semibold pl-6" style="font-family: 'Open Sans'">Line Items
        ({{data.cases?.length}})</span>
      <div class="pr-4 cursor-pointer"
        (click)="serviceGroupLookup(data.serviceGroups, authenticatedEmployee, data.vehicle, data.appointment, data.dropdowns, gmServiceFromTree)">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
          <path
            d="M12.5 1.625C9.61002 1.66126 6.84824 2.87134 4.80457 4.99675C2.7609 7.12217 1.59737 9.99443 1.5625 13C1.59737 16.0056 2.7609 18.8778 4.80457 21.0032C6.84824 23.1287 9.61002 24.3387 12.5 24.375C15.39 24.3387 18.1518 23.1287 20.1954 21.0032C22.2391 18.8778 23.4026 16.0056 23.4375 13C23.4026 9.99443 22.2391 7.12217 20.1954 4.99675C18.1518 2.87134 15.39 1.66126 12.5 1.625ZM18.75 13.8125H13.2812V19.5H11.7188V13.8125H6.25V12.1875H11.7188V6.5H13.2812V12.1875H18.75V13.8125Z"
            fill="#0054A6" />
        </svg>
      </div>
    </div>
    <div *ngFor="let case of data.cases | orderBy: 'case.sequence'; let i = index"
      class="relative flex flex-row w-full pb-5 shadow-lg bg-white rounded-lg p-4 mr-1 h-auto mb-2">
      <div class="absolute top-4 right-4 cursor-pointer"
        (click)="editAppointmentCase(data.serviceGroups, authenticatedEmployee, data.vehicle, data.appointment, data.dropdowns, gmServiceFromTree,case.case)">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path
            d="M14.5029 5.6637L10.7769 1.98151L12.0043 0.75411C12.3404 0.418037 12.7533 0.25 13.2431 0.25C13.7329 0.25 14.1455 0.418037 14.481 0.75411L15.7084 1.98151C16.0445 2.31758 16.2198 2.72321 16.2344 3.19838C16.2491 3.67356 16.0883 4.0789 15.7522 4.41438L14.5029 5.6637ZM13.2317 6.95685L3.93855 16.25H0.212524V12.524L9.50568 3.23082L13.2317 6.95685Z"
            fill="#0054A6" />
        </svg>
      </div>
      <div class="flex w-1/10">
        <span class="text-sm font-semibold border-2 rounded-full text-center w-6 h-6"
          style="font-family: 'Open Sans'; color: #555; border-color: #9747FF">{{i+1}}</span>
      </div>
      <div class="flex flex-col w-full">
        <div class="w-9/10">
          <span class="text-xs font-normal" style="font-family: 'Open Sans'; color: #444;  display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;">
            <b class="font-semibold">{{case.case.opCode}}</b> {{ case.case.opCode ? ' - ' : '' }}
            {{case.case.requestDescription}}
          </span>
        </div>
        <div *ngIf="case.services.length > 1" class="flex flex-col mt-3.5 text-xs font-normal underline cursor-pointer"
          style="color: #0054A6; font-family: 'Open Sans';" (click)="showServices(case.case, case.services)">
          Show Services
        </div>
        <div class="flex flex-row justify-between items-center mt-3.5 pr-4">
          <div class="w-3/4">
            <span class="text-xs font-semibold" style="font-family: 'Open Sans'; color: #555">
              {{ case.case.embedded?.warrantySubmissionType?.description }}</span> &bull;
            <span class="text-xs font-normal" style="font-family: 'Open Sans'; color: #555;">
              {{ case.case.technicianGroupName }}</span>
          </div>
          <div class="text-xs font-semibold text-black pl-2 text-right" style="font-family: 'Open Sans'">
            <span *ngIf="case.rate; else needsAssement">{{ case.rate | currency }}</span>
            <ng-template #needsAssement>
              <span>Needs Assessment</span>
            </ng-template>
          </div>
        </div>

        <div class="flex flex-row items-center place-content-between mt-3 pr-4">
          <div class="flex flex-row items-center">
            <sha-media-gallery-dialog-button [media$]="mediaStateService.getAppointmentCaseMedia(case.case)">
            </sha-media-gallery-dialog-button>
            <sha-media-upload-input class="ml-5" [params]="
          mediaStateService.buildMediaParams(data.mediaParams, {
                caseSequence: case.case.sequence,
                caption: case.case.requestDescription,
                galleryDescription:
                  case.case?.embedded && case.case?.embedded?.serviceGroup
                    ? case.case?.embedded?.serviceGroup.name
                    : case.case.requestDescription
              })
            ">
            </sha-media-upload-input>
          </div>
          <div class="cursor-pointer" (click)="deleteCase(case.case)">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M6.41666 19.25C5.91249 19.25 5.48074 19.0703 5.12141 18.711C4.76207 18.3517 4.58271 17.9202 4.58332 17.4167V5.5H3.66666V3.66667H8.24999V2.75H13.75V3.66667H18.3333V5.5H17.4167V17.4167C17.4167 17.9208 17.237 18.3526 16.8777 18.7119C16.5183 19.0713 16.0869 19.2506 15.5833 19.25H6.41666ZM15.5833 5.5H6.41666V17.4167H15.5833V5.5ZM8.24999 15.5833H10.0833V7.33333H8.24999V15.5833ZM11.9167 15.5833H13.75V7.33333H11.9167V15.5833Z"
                fill="#0054A6" />
            </svg>
          </div>
        </div>

        <!-- <div class="flex flex-col">
           <div class="flex flex-row place-items-center" style="color: rgb(82, 82, 82)" *ngIf="case.reservedParts">
            <div>
              <span class="primary-bullet">·</span>
              <div>
                <span class="font-medium">Parts reserved on this case.</span>
              </div>
            </div>
          </div>
        </div> -->

      </div>
    </div>
    <div *ngIf="data.cases && data.cases.length == 0" fxLayout="row" fxLayoutAlign="center center">
      <div class="flex shadow-lg bg-white rounded-lg p-4 mr-1 w-full h-20 items-center">
        <span class="text-base font-semibold" style="font-family: 'Open Sans'; color: #555;">No line items on this
          appointment.</span>
      </div>
    </div>
  </div>
  <ng-template #loadingLineItems>
    <div class="animated-background w-full h-64 mt-11 rounded-lg"></div>
  </ng-template>
</div>